import { create } from 'zustand';

interface VisitorCheckinState {
  isQRCodeReaderVisible: boolean;
  setQRCodeReaderVisible: (visible: boolean) => void;
  isMeetingModalVisible: boolean;
  setMeetingModalVisible: (visible: boolean) => void;
  isModalPrinterVisible: boolean;
  setModalPrinterVisible: (visible: boolean) => void;
  modalCheckVisitorNameVisible: boolean;
  setModalCheckVisitorNameVisible: (visible: boolean) => void;
  verifyPhoneNumberModal: boolean;
  setVerifyPhoneNumberModal: (visible: boolean) => void;
  resetAllModals(): void;
}

const useVisitorCheckinStore = create<VisitorCheckinState>((set) => ({
  isQRCodeReaderVisible: false,
  setQRCodeReaderVisible: (visible: boolean) => {
    set({ isQRCodeReaderVisible: visible });
  },
  isMeetingModalVisible: false,
  setMeetingModalVisible: (visible: boolean) => {
    set({ isMeetingModalVisible: visible });
  },
  isModalPrinterVisible: false,
  setModalPrinterVisible: (visible: boolean) => {
    set({ isModalPrinterVisible: visible });
  },
  modalCheckVisitorNameVisible: false,
  setModalCheckVisitorNameVisible: (visible: boolean) => {
    set({ modalCheckVisitorNameVisible: visible });
  },
  verifyPhoneNumberModal: false,
  setVerifyPhoneNumberModal: (visible: boolean) => {
    set({ verifyPhoneNumberModal: visible });
  },
  resetAllModals: () => {
    set({
      isQRCodeReaderVisible: false,
      isMeetingModalVisible: false,
      isModalPrinterVisible: false,
      modalCheckVisitorNameVisible: false,
      verifyPhoneNumberModal: false,
    });
  },
}));

export default useVisitorCheckinStore;
